import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Carousel, Button, Form, Row, Col, Modal } from "react-bootstrap";
import "./style/packermover.css"; // Custom CSS file for styling
import { Link } from "react-router-dom";
import axios from "axios";
import Select from "react-select";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { MdFlightTakeoff, MdOutlineFlight } from "react-icons/md";

// Use Google Maps API like the mobile app
const API_KEY = "AIzaSyClbig43rDJiDAjE8QVefX2LNZpczeBt5w";

function PackerMover() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const [relocationType, setRelocationType] = useState("withinCity");
  const [city, setCity] = useState("");
  const [shiftingFrom, setShiftingFrom] = useState("");
  const [shiftingTo, setShiftingTo] = useState("");
  const [lat, setlat] = useState("");
  const [lang, setlang] = useState("");
  const [latto, setlatto] = useState("");
  const [langto, setlangto] = useState("");

  const [Allcity, setAllCity] = useState([]);

  const getcity = () => {
    try {
      axios
        .get("https://vrpmpro.com/api/propertyForOwner/getAddCity")
        .then(function (response) {
          if (response.status === 200) {
            // console.log(response.data);
            setAllCity(response.data.cityList1);
            return;
          } else {
            alert("Can't able to fetch ");
            return;
          }
        });
    } catch (error) {
      console.log(error.message.data);
      alert("Can't able  to fetch");
      return;
    }
  };

  useEffect(() => {
    getcity();
  }, []);

  const [shiftingDate, setShiftingDate] = useState("");
  const [showModal, setShowModal] = useState(false);

  const [options, setOptions] = useState([]);

  const handleSearch = async (inputValue) => {
    if (!inputValue) return;
    
    // For international, don't restrict to India
    const components = relocationType === "International" ? "" : "&components=country:IN";
    
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
      inputValue
    )}&key=${API_KEY}${components}`;

    try {
      const response = await axios.get(url);
      const results = response.data.results;

      const formattedOptions = results.map((result) => ({
        value: {
          lat: result.geometry.location.lat,
          lng: result.geometry.location.lng
        },
        label: result.formatted_address,
      }));

      setOptions(formattedOptions);
    } catch (error) {
      console.error("Error fetching geocode data:", error);
      setOptions([]);
    }
  };

  const handleInputChange = (inputValue) => {
    handleSearch(inputValue);
  };

  const handleChange1 = (options) => {
    setShiftingFrom(options?.label);
    setlat(options?.value.lat);
    setlang(options?.value?.lng);
  };

  const [optionto, setOptionsto] = useState([]);
  const handleSearchto = async (inputValue) => {
    if (!inputValue) return;
    
    // For international, don't restrict to India
    const components = relocationType === "International" ? "" : "&components=country:IN";
    
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
      inputValue
    )}&key=${API_KEY}${components}`;

    try {
      const response = await axios.get(url);
      const results = response.data.results;

      const formattedOptions = results.map((result) => ({
        value: {
          lat: result.geometry.location.lat,
          lng: result.geometry.location.lng
        },
        label: result.formatted_address,
      }));

      setOptionsto(formattedOptions);
    } catch (error) {
      console.error("Error fetching geocode data:", error);
      setOptionsto([]);
    }
  };

  const handleInputChangeto = (inputValue) => {
    handleSearchto(inputValue);
  };

  const handleChangeto = (options) => {
    setShiftingTo(options?.label);
    setlatto(options?.value.lat);
    setlangto(options?.value?.lng);
  };
  const [optionforshifting, setoptionforshifting] = useState([]);
  const shiftingfromsearch = async (inputValue) => {
    if (!inputValue) return;
    if (!city) return alert("Please select city!");
    
    try {
      const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
        `${inputValue}, ${city}, India`
      )}&key=${API_KEY}&components=country:IN`;

      const response = await axios.get(url);
      const results = response.data.results;

      const formattedOptions = results.map((result) => ({
        value: {
          lat: result.geometry.location.lat,
          lng: result.geometry.location.lng
        },
        label: result.formatted_address,
      }));
      
      setoptionforshifting(formattedOptions);
    } catch (error) {
      console.error("Error fetching geocode data:", error);
      setoptionforshifting([]);
    }
  };

  const handleInputChangeser = (inputValue) => {
    shiftingfromsearch(inputValue);
  };

  const dataToSend = {
    service: relocationType,
    city: city,
    shiftingFrom,
    shiftingTo,
    lat,
    lang,
    latto,
    langto,
    shiftingDate,
  }; // Example data to pass

  const queryParams = new URLSearchParams(dataToSend).toString();
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <meta content="width=device-width, initial-scale=1.0" name="viewport" />
        <title>Packers and Movers</title>
      </Helmet>
      <header className="header">
        <div className="container">
          <h1>India's Largest Packers And Movers</h1>
          <p>Service that fits your budget with quality assurance!</p>
          {/* <div className="features">
            <div className="feature-item">
              <img
                alt="NB Protect Icon"
                height="50"
                src="https://storage.googleapis.com/a1aa/image/gkUo9Dn0vaLWChteB0F39mySanH34zp4cOjcCqfha1eYAElnA.jpg"
                width="50"
              />
              <p>NB Protect</p>
              <p>Household damage protection</p>
            </div>
            <div className="feature-item">
              <img
                alt="Rating Icon"
                height="50"
                src="https://storage.googleapis.com/a1aa/image/u5NkfCZj35xMTyq8aqs30hejgEm0q8G531zYiHYjGaNGAiyTA.jpg"
                width="50"
              />
              <p>4.8 / 5 Rating</p>
              <p>Timely Pickup & Delivery</p>
            </div>
            <div className="feature-item">
              <img
                alt="Reliable Packaging Icon"
                height="50"
                src="https://storage.googleapis.com/a1aa/image/another-rating-icon.jpg"
                width="50"
              />
              <p>4.9 / 5 Rating</p>
              <p>Reliable Packaging</p>
            </div>
          </div> */}
        </div>
      </header>
      <div className="container">
        <Row className="zindex-sticky top-5 ">
          <Col md={8}>
            <Carousel>
              <Carousel.Item>
                <img
                  alt="Packers and Movers Image 1"
                  className="d-block w-100"
                  height="400"
                  src="https://storage.googleapis.com/a1aa/image/2H3Pw35f28TmRCxKftlIvvKYnFuM7tCENYfC102qAp7aAElnA.jpg"
                  width="800"
                />
              </Carousel.Item>
              <Carousel.Item>
                <img
                  alt="Packers and Movers Image 2"
                  className="d-block w-100"
                  height="400"
                  src="https://storage.googleapis.com/a1aa/image/Fnss5dGf0XWYDymKS090fg7BI2fMsXgBH05nILSxMmvQAElnA.jpg"
                  width="800"
                />
              </Carousel.Item>
              <Carousel.Item>
                <img
                  alt="Packers and Movers Image 3"
                  className="d-block w-100"
                  height="400"
                  src="https://storage.googleapis.com/a1aa/image/hczfGUCs0IXMfkwUYcKv8vrIG8XFZ9w7hCw7RgxYUHRKAiyTA.jpg"
                  width="800"
                />
              </Carousel.Item>
            </Carousel>
          </Col>

          <Col md={4} className="sticky-col  ">
            <div className="relocate-form">
              <h5>Where are you going to relocate?</h5>{" "}
              <div className="form-group mb-3">
                {" "}
                <label className="form-label">Relocation Type</label>{" "}
                <div className="button-group d-flex gap-3">
                  {" "}
                  <button
                    className={`${
                      relocationType === "withinCity"
                        ? "btn btn-danger   "
                        : "btn btn-outline-danger "
                    }`}
                    onClick={() => setRelocationType("withinCity")}
                  >
                    {" "}
                    Within City{" "}
                  </button>{" "}
                  <button
                    className={`${
                      relocationType === "betweenCities"
                        ? "btn btn-danger   "
                        : "btn btn-outline-danger "
                    }`}
                    onClick={() => setRelocationType("betweenCities")}
                  >
                    {" "}
                    Between Cities{" "}
                  </button>{" "}
                  <button
                    className={`${
                      relocationType === "International"
                        ? "btn btn-danger   "
                        : "btn btn-outline-danger "
                    }`}
                    onClick={() => setRelocationType("International")}
                  >
                    {" "}
                    International <MdOutlineFlight />{" "}
                  </button>{" "}
                </div>{" "}
              </div>{" "}
              {relocationType === "withinCity" && (
                <div className="form-group mb-3">
                  {" "}
                  <label className="form-label" htmlFor="city">
                    {" "}
                    Select City{" "}
                  </label>{" "}
                  <select
                    id="city"
                    className="form-control"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                  >
                    {" "}
                    <option value="">Select an option</option>{" "}
                    {Allcity.map((data, index) => (
                      <option key={data._id || index} value={data.city}>{data.city}</option>
                    ))}
                    ))}
                  </select>{" "}
                </div>
              )}{" "}
              {relocationType === "withinCity" && (
                <>
                  {" "}
                  <div className="form-group mb-3">
                    {" "}
                    <label className="form-label" htmlFor="shiftingFrom">
                      {" "}
                      Shifting From{" "}
                    </label>{" "}
                    <Select
                      options={optionforshifting}
                      // className="form-control"
                      //  value={shiftingFrom}
                      onInputChange={handleInputChangeser}
                      onChange={handleChange1}
                      placeholder="Enter Shifting from area..."
                    />
                  </div>
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="shiftingTo">
                      Shifting To
                    </label>
                    <Select
                      options={optionforshifting}
                      // className="form-control"
                      //  value={shiftingTo}
                      onInputChange={handleInputChangeser}
                      onChange={handleChangeto}
                      placeholder="Enter Shifting to area..."
                    />
                  </div>
                  <div className="form-group">
                    <Link to={`/packers_movers_vehicle?${queryParams}`}>
                      <button className="btn btn-danger">Check Prices</button>
                    </Link>
                  </div>
                </>
              )}
              {(relocationType === "betweenCities" ||
                relocationType === "International") && (
                <>
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="shiftingFrom">
                      Shifting From
                    </label>
                    <Select
                      options={options}
                      // className="form-control"
                      //  value={shiftingFrom}
                      onInputChange={handleInputChange}
                      onChange={handleChange1}
                      placeholder="Enter Shifting from city..."
                    />
                  </div>
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="shiftingTo">
                      Shifting To
                    </label>
                    <Select
                      options={optionto}
                      // className="form-control"
                      //  value={shiftingTo}
                      onInputChange={handleInputChangeto}
                      onChange={handleChangeto}
                      placeholder="Enter Shifting to city..."
                    />
                    {/* <input
                      type="text"
                      id="shiftingTo"
                      className="form-control"
                      placeholder="Shifting To"
                      value={shiftingTo}
                      onChange={(e) => setShiftingTo(e.target.value)}
                    /> */}
                  </div>
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="shiftingDate">
                      Shifting Date
                    </label>
                    <input
                      type="date"
                      id="shiftingDate"
                      className="form-control"
                      value={shiftingDate}
                      onChange={(e) => setShiftingDate(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <Link to={`/packers_movers_details?${queryParams}`}>
                      <button className="btn btn-danger">Check Prices</button>
                    </Link>
                  </div>
                </>
              )}
              {/* <div className="form-group">
                <Link to="/packers_movers_details">
                  <button className="btn btn-danger">Check Prices</button>
                </Link>
              </div> */}
            </div>
          </Col>
        </Row>

        <Row>
          <Col xs={8}>
            <div className="card ">
              <h1 className="text-center mt-3 fs-4">Services we offer</h1>
              <div className="d-flex justify-content-center gap-5">
                <div
                  onClick={() => setRelocationType("withinCity")}
                  style={{ cursor: "pointer", textAlign: "center" }}
                >
                  <img src="./img/block.png" className="w-1" width={50} />
                  <h1 className="fs-5">Within City</h1>
                </div>
                <div
                  onClick={() => setRelocationType("betweenCities")}
                  style={{ cursor: "pointer", textAlign: "center" }}
                >
                  <img src="./img/delivery.png" className="" width={50} />
                  <h1 className="fs-5">Between City</h1>
                </div>
                <div
                  onClick={() => setRelocationType("International")}
                  style={{ cursor: "pointer", textAlign: "center" }}
                >
                  <MdFlightTakeoff size={50} />
                  <h1 className="fs-5">International</h1>
                </div>
                <div style={{ textAlign: "center" }}>
                  <img
                    src="./img/vehicle-insurance.png"
                    className=""
                    width={50}
                  />
                  <h1 className="fs-5">Vehicle Shifting</h1>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col xs={8}>
            <div className="card">
              <h1 className="text-center mt-3 fs-4">How it Works?</h1>
              <div className="d-flex  gap-5 flex-column p-5">
                <div className="d-flex gap-3">
                  <img src="./img/shifting-requirement.svg" width={50} />
                  <div>
                    <h5 className="fs-5">Share your Shifting Requirement</h5>
                    <p>
                      Help us by providing when and where do you want to move
                    </p>
                  </div>
                </div>
                <div className="d-flex gap-3">
                  <img src="./img/instant-quote.svg" className="" width={50} />
                  <div>
                    <h1 className="fs-5">Receive Free Instant Quote</h1>
                    <p>
                      Get guaranteed lowest priced quote for your shifting
                      instantly
                    </p>
                  </div>
                </div>
                <div className="d-flex gap-3">
                  <img
                    src="./img/quality-service-expert.svg"
                    className=""
                    width={50}
                  />
                  <div>
                    <h1 className="fs-5">Assign Quality Service Expert</h1>
                    <p>
                      To ensure safe relocation quality service expert will be
                      allotted or your movement
                    </p>
                  </div>
                </div>
                <div className="d-flex gap-3">
                  <img src="./img/heavy-lifting.svg" className="" width={50} />
                  <div>
                    <h1 className="fs-5">Leave the Heavy Lifting to Us</h1>
                    <p>
                      Enjoy hassle-free on time movement of your household goods
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default PackerMover;
